import { fetchLoan } from 'actions/loans';
import asyncDispatcher from 'utils/asyncDispatcher';

export const updateRepaymentStatus = (repaymentId, loanId, status) => (dispatch, getState) => {
  const { api } = getState().app;

  return api.updateRepayment(repaymentId, status)
    .then(resp => {
      dispatch(fetchLoan(loanId));
    });
};



// WEBPACK FOOTER //
// ./src/actions/repayments.js